import * as React from 'react';

import {SectionLabel} from 'shells/typography/section-label';

import {GetLead} from '../get-lead';

import {AssigneeButton} from './buttons/assignee-button';

import styles from './lead-assignee.module.css';

type Props = {
    leadId: string;
};

export function LeadAssignee(props: Props) {
    return (
        <GetLead leadId={props.leadId}>
            {/* @ts-expect-error */}
            {({lead}) => {
                if (!lead) return null;

                return (
                    <div className={styles['lead-assignee']}>
                        <SectionLabel noBottomBorder={true}>Assignee</SectionLabel>
                        <AssigneeButton lead={lead} />
                    </div>
                );
            }}
        </GetLead>
    );
}
